// hooks/useAtualizarDados.ts
import { useEffect, useState } from "react";
import { Parceiro } from "../../../interfaces/Parceiro";
import { buscarParceiroByIdService } from "../../../services/buscarParceiroByIdService";

export const useParceiro = (isModalOpen: boolean, parceiroId: number) => {
  const [parceiro, setParceiro] = useState<Parceiro[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isModalOpen) {
      const buscar = async () => {
        setIsLoading(true);
        const data = await buscarParceiroByIdService(parceiroId);

        setParceiro(data);
        setIsLoading(false);
      };

      buscar();
    }
  }, [parceiroId, isModalOpen]);

  return { parceiro, isLoading };
};
